import { uniqueId } from "library/database/split-id.mjs"
import { deriveGuidFrom } from "library/guid/index.mjs"

export function getRegisterTypeId(registerId, type) {
    return `${uniqueId(registerId)}-${deriveGuidFrom(typeof type === "string" || !type ? type : type.name)}`
}
